<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import SalesOrderForm from "./components/SalesOrderForm.vue"

defineProps<{
  sales_order: {
    id?: number | null
    company_id: number | ""
    customer_id: number | ""
    delivery_date: string
    estimated_tax_percent: string
    estimated_freight_cents: string
    packaging_percent: string
    overhead_percent: string
    indirect_costs_percent?: string
    payment_terms: string
    validity_date: string
    freight_mode: string
    commercial_notes: string
    installments: Array<{
      due_date: string
      amount: string
    }>
    items: Array<{
      id?: number | null
      product_id: number | ""
      quantity: string
      unit_price_cents: string
    }>
  }
  companies: Array<{ id: number; name: string }>
  customers: Array<{ label: string; value: number }>
  products: Array<{ label: string; value: number }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <SalesOrderForm
      title="Novo pedido de venda"
      subtitle="Registre a venda e gere snapshot projetado de custo, margem e lucro."
      :sales-order="sales_order"
      :companies="companies"
      :customers="customers"
      :products="products"
      :errors="errors"
    />
  </AppShell>
</template>
